module.exports = __webpack_public_path__ + "static/media/social-in-white.51ced5f1.svg";